<template>
  <button-dialog-container
    :btn-icon="icon"
    :size="getSize"
    :only-icon="true"
    :no-tool-tip="noToolTip"
    :width-dialog="1000"
    :dialog-viewer.sync="dialog"
    :title-tool-tip="titleToolTip"
    @ok-pushed="createWidget"
    @cancel-pushed="outsideClick"
    @outside-click="outsideClick"
  >
    <v-container class="pa-4">
      <v-row>
        <v-col cols="7">
          <v-row>
            <v-stage
              id="weatherStage"
              ref="creationPageWorkspace"
              class="stage"
              :config="configKonva"
            />
          </v-row>
          <v-row>
            <v-col class="mt-2">
              <v-text-field
                v-model="cityName"
                :label="label"
                :placeholder="placeholder"
                hide-details
                clearable
                autofocus
                dense
                @click:clear="reset()"
              >
                <template v-slot:append-outer>
                  <v-btn
                    class="mt-n1"
                    :disabled="cityName == ''"
                    @click="initCity()"
                  >
                    {{ $t("creation.tools.dialog.rss.generate") }}
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          class="pa-0"
          cols="1"
        >
          <v-divider
            class="ml-4"
            vertical
          />
        </v-col>
        <v-col cols="4">
          <v-expansion-panels
            v-model="optionData"
            accordion
            class="pa-0 ml-n5"
            popout
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("weather.title-display") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-radio-group
                    v-model="orientation"
                    row
                    class="marginZero"
                    @change="changeParams()"
                  >
                    <v-radio
                      class="d-flex pa=0 ma=0"
                      :label="$t('orientation.portrait')"
                      :value="true"
                      off-icon="mdi-crop-portrait"
                      on-icon="mdi-crop-portrait"
                    />
                    <v-radio
                      class="d-flex pa=0 ma=0"
                      :label="$t('orientation.landscape')"
                      :value="false"
                      off-icon="mdi-crop-landscape"
                      on-icon="mdi-crop-landscape"
                    />
                  </v-radio-group>
                </v-row>
                <v-row dense>
                  <v-col>
                    {{ getLabelPosition }}
                  </v-col>
                  <v-col>
                    <v-switch
                      v-model="position"
                      class="marginZero"
                      inset
                      @change="changeParams()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="nbDay"
                      :items="daySelect"
                      item-text="name"
                      item-value="value"
                      :label="$t('weather.forecast')"
                      @change="changeParams()"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("weather.title-data") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list
                  dense
                  class="listdata mr-n10"
                >
                  <v-list-item-group>
                    <draggable
                      v-model="params"
                      @end="changeParams()"
                    >
                      <template v-for="(param, index) in params">
                        <v-list-item
                          v-if="param != null"
                          :key="index"
                        >
                          <v-list-item-content class="pa-0 mx-0 mr-n10">
                            <v-checkbox
                              v-model="param.value"
                              :label="$t('weather.' + param.name)"
                              dense
                              hide-details
                              @change="changeParams()"
                            />
                          </v-list-item-content>
                          <v-list-item-icon>
                            <!--
                            <v-checkbox
                              v-if="param.name == 'sunset'"
                              v-model="param.icon"
                              class="mt-n1"
                              dense
                              hide-details
                              off-icon="mdi-weather-sunset-down"
                              on-icon="mdi-weather-sunset-down"
                              @change="changeParams()"
                            />
                            <v-checkbox
                              v-if="param.name == 'sunrise'"
                              v-model="param.icon"
                              class="mt-n1"
                              dense
                              hide-details
                              off-icon="mdi-weather-sunset-up"
                              on-icon="mdi-weather-sunset-up"
                              @change="changeParams()"
                            />
                            <v-checkbox
                              v-if="param.name == 'windSpeed'"
                              v-model="param.icon"
                              class="mt-n1"
                              dense
                              hide-details
                              off-icon="mdi-windsock"
                              on-icon="mdi-windsock"
                              @change="changeParams()"
                            />
                            <v-checkbox
                              v-if="param.name == 'humidity'"
                              v-model="param.icon"
                              class="mt-n1"
                              dense
                              hide-details
                              off-icon="mdi-water-percent"
                              on-icon="mdi-water-percent"
                              @change="changeParams()"
                            />
                            -->
                            <v-icon>mdi-drag-horizontal</v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </template>
                    </draggable>
                  </v-list-item-group>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("weather.title-custom") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-2">
                  <v-slider
                    v-if="(position && !orientation) || onlyIcon"
                    v-model="sizeIcon"
                    step="1"
                    min="1"
                    max="10"
                    thumb-label
                    ticks
                    append-icon="mdi-plus-circle-outline"
                    prepend-icon="mdi-minus-circle-outline"
                    @click:append="sizeIconMore"
                    @click:prepend="sizeIconLess"
                    @input="changeParams()"
                  />
                </v-row>
                <v-row>
                  <v-combobox
                    v-model="size"
                    :items="btnSize"
                    dense
                    outlined
                    :label="$t('option.size')"
                    @change="clickSize()"
                  />
                </v-row>
                <v-row>
                  <v-combobox
                    v-model="font"
                    :items="btnFont"
                    dense
                    outlined
                    :label="$t('option.font')"
                    @change="clickFont()"
                  />
                </v-row>
                <v-row>
                  <v-slider
                    v-if="position"
                    v-model="entraxe"
                    step="1"
                    min="1"
                    max="10"
                    thumb-label
                    ticks
                    append-icon="mdi-plus-circle-outline"
                    prepend-icon="mdi-minus-circle-outline"
                    @click:append="entraxeMore"
                    @click:prepend="entraxeLess"
                    @input="changeParams()"
                  />
                </v-row>
                <v-row v-if="false">
                  {{ $t("weather.color-icon") }} :
                  <v-radio-group
                    v-model="colorIcon"
                    row
                    class="marginZero ml-2"
                    @change="changeParams()"
                  >
                    <v-radio
                      class="d-flex pa=0 ma=0"
                      :label="$t('settings.themes')[1].text"
                      :value="true"
                    />
                    <v-radio
                      class="d-flex pa=0 ma=0"
                      :label="$t('settings.themes')[0].text"
                      :value="false"
                    />
                  </v-radio-group>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import draggable from "vuedraggable";

// Libs
import Konva from "konva";

// Tools
const weatherApi = require("../Tools/WeatherApi");

// Controllers
import { GeneratedWeather } from "../CreationPage/Generator/GeneratedWeather.js";

export default {
  components: {
    buttonDialogContainer,
    draggable,
  },
  props: {
    currentObject: {
      type: Object,
      default: () => {},
    },
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    toolName: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: false,
    },
    getSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      displayName: false,
      position: false,
      orientation: true,
      dialog: false,
      size: 28,
      font: this.$store.state.vars.font.default,
      btnFont: this.$store.state.vars.font.family,
      btnSize: this.$store.state.vars.font.size,
      cityName: "",
      textEntered: "",
      baseConfigKonva: {
        x: 0,
        y: 0,
        width: 500,
        height: 450,
        scale: {
          x: this.scale,
          y: this.scale,
        },
      },
      daySelect: [
        { name: this.$t("calendar.weather.today"), value: 0 },
        { name: this.$t("calendar.weather.tomorrow"), value: 1 },
        {
          name: this.$t("calendar.weather.in") + " 2 " + this.$t("calendar.weather.days"),
          value: 2,
        },
        {
          name: this.$t("calendar.weather.in") + " 3 " + this.$t("calendar.weather.days"),
          value: 3,
        },
        {
          name: this.$t("calendar.weather.in") + " 4 " + this.$t("calendar.weather.days"),
          value: 4,
        },
        {
          name: this.$t("calendar.weather.in") + " 5 " + this.$t("calendar.weather.days"),
          value: 5,
        },
        {
          name: this.$t("calendar.weather.in") + " 6 " + this.$t("calendar.weather.days"),
          value: 6,
        },
        {
          name: this.$t("calendar.weather.in") + " 7 " + this.$t("calendar.weather.days"),
          value: 7,
        },
      ],
      params: [
        { name: "icon", value: true },
        { name: "temp", value: true },
        { name: "city", value: true },
        { name: "description", value: false },
        { name: "windSpeed", value: false, icon: false },
        { name: "humidity", value: false, icon: false },
        { name: "sunrise", value: false, icon: false },
        { name: "sunset", value: false, icon: false },
      ],
      nbDay: 0,
      currentLayer: undefined,
      maxW: 0,
      maxH: 0,
      totalHeight: 0,
      totalWidth: 0,
      stagePos: 0,
      optionData: 1,
      entraxe: 5,
      sizeIcon: 3,
      colorIcon: true,
      onlyIcon: false,
    };
  },
  computed: {
    exceedWidth() {
      if (this.stage.width() > this.totalWidth) {
        return false;
      } else {
        return true;
      }
    },
    getLabelPosition() {
      if (!this.position) {
        return this.$t("weather.position.line");
      } else {
        return this.$t("weather.position.column");
      }
    },
    stage() {
      return this.$refs.creationPageWorkspace.getStage();
    },
    configKonva() {
      return this.baseConfigKonva;
    },
    indexOfSelectedLayer: {
      get() {
        let index = parseInt(this.params.indexOf(this.layerSelected));
        if (index < 0) {
          return undefined;
        }
        return index;
      },
      set(value) {
        this.currentLayer = value;
      },
    },
    open() {
      return this.$store.state.widget.openEditWeather;
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        this.setConfig();
        this.dialog = true;
        this.dblclick = true;
        this.$store.dispatch("editClose").widget;
      }
    },
  },
  methods: {
    initCity() {
      const date = new Date();
      const currentDate = date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
      const currentHour = date.getHours();

      const config = {
        city: this.cityName,
        units: "metric",
        lang: this.$i18n.locale,
      };

      if (this.nbDay < 0 || isNaN(this.nbDay)) {
        this.nbDay = 0;
      }

      if (this.nbDay > 7) {
        this.nbDay = 7;
      }

      const day = this.nbDay;

      weatherApi
        .getWeather(config)
        .then((response) => {
          localStorage.weatherDate = currentDate;
          localStorage.weatherHour = currentHour;
          localStorage.weatherDay = this.nbDay;
          localStorage.weatherIcon = response[day].icon;
          localStorage.weatherTemp = response[day].temp;
          localStorage.weatherCity = response[day].city;
          localStorage.weatherDescription = response[day].description;
          localStorage.weatherHumidity = response[day].humidity;
          localStorage.weatherPressure = response[day].pressure;
          localStorage.weatherRain = response[day].rain;
          localStorage.weatherSunrise = response[day].sunrise;
          localStorage.weatherSunset = response[day].sunset;
          localStorage.weatherWindDirection = response[day].wind_direction;
          localStorage.weatherWindSpeed = response[day].wind_speed;

          this.changeParams();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeParams() {
      // ON DIALOG
      const layer = new Konva.Layer();

      this.stage.destroyChildren();

      const fullParams = this.generatedFullParams();
      const weatherItem = new GeneratedWeather();
      weatherItem.initVal(fullParams).then(() => {
        const group = weatherItem.changParams();

        layer.add(group);
        this.stage.add(layer);

        try {
          this.stage.draw();
        } catch (err) {
          console.error(err);
        }
      });
    },
    generatedFullParams() {
      const params = this.params;

      const fullParams = {
        params: params,
        onlyIcon: this.onlyIcon,
        entraxe: this.entraxe,
        size: this.size,
        sizeIcon: this.sizeIcon,
        maxW: this.maxW,
        maxH: this.maxH,
        colorIcon: this.colorIcon,
        totalWidth: this.totalWidth,
        totalHeight: this.totalHeight,
        position: this.position,
        orientation: this.orientation,
        font: this.font,
        color: this.color,
        nbDay: this.nbDay,
      };

      return fullParams;
    },
    setConfig() {
      const currentData = this.currentObject.dataWeather;

      this.cityName = currentData.city;
      this.nbDay = currentData.fullParams.nbDay;
      this.params = currentData.fullParams.params;
      this.onlyIcon = currentData.fullParams.onlyIcon;
      this.entraxe = currentData.fullParams.entraxe;
      this.size = currentData.fullParams.size;
      this.sizeIcon = currentData.fullParams.sizeIcon;
      this.maxW = currentData.fullParams.maxW;
      this.maxH = currentData.fullParams.maxH;
      this.colorIcon = currentData.fullParams.colorIcon;
      this.totalWidth = currentData.fullParams.totalWidth;
      this.totalHeight = currentData.fullParams.totalHeight;
      this.position = currentData.fullParams.position;
      this.orientation = currentData.fullParams.orientation;
      this.font = currentData.fullParams.font;
      this.color = currentData.fullParams.color;
    },
    createWidget() {
      const item = this.stage.children[0].children[0];
      item.id("Weather");
      item.width(item.getClientRect({ skipTransform: true }).width);
      item.height(item.getClientRect({ skipTransform: true }).height);

      const fullParams = this.generatedFullParams();
      const dataWeather = {
        city: this.cityName,
        size: this.size,
        font: this.font,
        color: this.color,
        nbDay: this.nbDay,
        group: item,
        fullParams: fullParams,
      };

      if (this.dblclick) {
        this.$emit("editElement", {
          name: "weather",
          content: dataWeather,
          config: this.currentObject.konvaObjectOption,
        });
        this.dblclick = false;
      } else {
        if (this.toolName) {
          this.$emit("toolSelectedFromDialog", this.toolName);
        }

        this.$emit("weatherSelected", dataWeather);
      }

      this.reset();
    },
    clickSize() {
      if (this.size > 8 && this.size < 150) {
        this.changeParams();
      } else {
        this.size = 30;
      }
    },
    clickFont() {
      this.changeParams();
    },
    reset() {
      this.cityName = "";
      this.textEntered = "";
      this.nbDay = 0;
      (this.params = [
        { name: "icon", value: true },
        { name: "temp", value: true },
        { name: "city", value: true },
        { name: "description", value: false },
        { name: "windSpeed", value: false, icon: false },
        { name: "humidity", value: false, icon: false },
        { name: "sunrise", value: false, icon: false },
        { name: "sunset", value: false, icon: false },
      ]),
        this.stage.clear();
      this.stage.clearCache();
      this.stage.destroyChildren();
    },
    outsideClick() {
      this.reset();
    },
    entraxeLess() {
      this.entraxe = this.entraxe - 1 || 0;
      this.changeParams();
    },
    entraxeMore() {
      this.entraxe = this.entraxe + 1 || 10;
      this.changeParams();
    },
    sizeIconLess() {
      this.speed = this.speed - 10 || 0;
      this.changeParams();
    },
    sizeIconMore() {
      this.speed = this.speed + 10 || 100;
      this.changeParams();
    },
  },
};
</script>

<style>
.marginZero {
  margin-top: 0px;
}

.separation {
  display: inline-flex;
  flex-direction: center;
  align-content: center;
  align-self: center;
}

.listdata {
  overflow-y: auto;
  max-height: calc(100vh - 750px);
}

#weatherStage .konvajs-content {
  overflow: auto;
  max-width: 510px;
  max-height: 460px;
}
</style>
